/**
 * Utility functions for interacting with localStorage in React.
 */

// Save data to localStorage
export const setLocalStorage = (key, value) => {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.error('Error saving to localStorage', e);
    }
};

// Get data from localStorage
export const getLocalStorage = (key) => {
    try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    } catch (e) {
        console.error('Error reading from localStorage', e);
        return null;
    }
};

// Remove data from localStorage
export const removeLocalStorage = (key) => {
    try {
        localStorage.removeItem(key);
    } catch (e) {
        console.error('Error removing from localStorage', e);
    }
};